//@ts-check
import React from "react";
import { useAppDispatch } from "src/utils/ReduxHooks";
import useTypedSelector from "utils/useTypedSelector";
import { useI18n } from "components/lni18n";
import { imagePickerDuck } from "./ImagePickerDuck";
import LnIcon from "components/LnIcon";
import { Collapse } from "reactstrap";
import CardTitle from "reactstrap/lib/CardTitle";
import ImageInfoForPart from "./ImageInfoForPart";

const ImageInfo = (props) => {

    /** @type {import('redux').Dispatch<any>} */
    const dispatch = useAppDispatch();
    const { languageService: t } = useI18n();

    const { selectedImage, currentImage, deleteRequested } = useTypedSelector(state => state.imagepicker);
    const { user: currentUser } = useTypedSelector(state => state.login);

    const onDeleteRequest = (state) => {
        dispatch(imagePickerDuck.setDeleteRequested(state));
    }

    const doDelete = () => {
        dispatch(imagePickerDuck.deleteCurrentImage());
    }

    const totalOthersCount = currentImage.Overview.TotalOtherCount;

    return <>

        {currentUser.Id === selectedImage.User.Id && currentImage && <>

            <button className="ml-auto d-block btn btn-inverse btn-danger" onClick={() => onDeleteRequest(true)} ><LnIcon className="icon-medium filter-red" name="delete" /></button>


            <Collapse isOpen={deleteRequested} >
                <div className="mb-4">
                    {(currentImage.Overview.TotalReferenceCount > 0) && t.getText("image.used.delete.warning")}
                    <br />
                    {t.getText("sure_to_delete")}
                    <div className="mt-3 d-flex justify-content-between">
                        <button className="btn btn-inverse" onClick={() => onDeleteRequest(false)} >{t.getText("cancel")}</button>
                        <button className="btn btn-danger btn-inverse" onClick={() => doDelete()} >{t.getText("image.delete")}</button>
                    </div>
                </div>
            </Collapse>


        </>
        }

        {currentImage.Overview.TotalReferenceCount > 0 ? <>
            <h3 className="mb-3">{t.getText("in.use")}</h3>
            <div >
                {currentImage.Overview.CourseParts.length > 0 && <div className="mb-5 card">
                    <div className="card-header">
                        <CardTitle> {t.getText("courseparts")} </CardTitle>
                    </div>
                    <div className="card-body">

                        {currentImage.Overview.CourseParts.map((c, i) => <ImageInfoForPart key={i} data={c} />
                        )}
                    </div>
                </div>}

                { totalOthersCount > 0  &&

                    <div className="card">
                        <div className="card-header">
                            <CardTitle> {t.getText("additional")} </CardTitle>
                        </div>
                        <div className="card-body">
                            <table className="table table-sm table-borderless">

                                <thead>
                                    <tr>
                                        <th>{t.getText("type")}</th>
                                        <th>{t.getText("amount")}</th>
                                    </tr>
                                </thead>

                                <tbody>


                                    {currentImage.Overview.MailCount > 0 && <tr>
                                        <td>
                                            {t.getText("email")}
                                        </td>
                                        <td>
                                            {currentImage.Overview.MailCount}
                                        </td>
                                    </tr>}

                                    {currentImage.Overview.NotificationCount > 0 && <tr >
                                        <td>
                                            {t.getText("notifications")}
                                        </td>
                                        <td>
                                            {currentImage.Overview.NotificationCount}
                                        </td>

                                    </tr>}

                                    {currentImage.Overview.StudentCommentCount > 0 && <tr>
                                        <td>
                                            {t.getText("student.notes")}
                                        </td>
                                        <td>
                                            {currentImage.Overview.StudentCommentCount}
                                        </td>

                                    </tr>}

                                    {currentImage.Overview.CourseAddonCount > 0 && <tr>
                                        <td>
                                            {t.getText("courseaddons")}
                                        </td>
                                        <td>
                                            {currentImage.Overview.CourseAddonCount}
                                        </td>

                                    </tr>}

                                    {currentImage.Overview.UnitCount > 0 && <tr>
                                        <td>
                                            {t.getText("units")}

                                        </td>
                                        <td>
                                            {currentImage.Overview.UnitCount}
                                        </td>
                                    </tr>}


                                    { ( currentImage.Overview.ClassDiplomaCount > 0 
                                            || currentImage.Overview.CourseDiplomaCount > 0) && <tr>
                                        <td>
                                            {t.getText("diploma")}

                                        </td>
                                        <td>
                                            {currentImage.Overview.ClassDiplomaCount + currentImage.Overview.CourseDiplomaCount}
                                        </td>
                                    </tr>}


                                </tbody>
                            </table>
                        </div>
                    </div>
                }

            </div>
        </> : <h4>{t.getText("image.overview.not.used.anywhere")}</h4>
        }

    </>
}

export default ImageInfo;
